var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpStatus } from 'http-core-constants';
function parseResponse(text) {
    try {
        return JSON.parse(text);
    }
    catch (e) {
        console.error('Can\'t parse response', text);
        return text;
    }
}
export class ServiceError extends Error {
    constructor(message, code) {
        super(message);
        this.code = code;
    }
}
export const callService = (url, method, request) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const response = yield fetch(url, {
        method,
        body: JSON.stringify(request)
    });
    if (response.status >= 500) {
        throw new ServiceError(`Server Error - Something went wrong`, response.status);
    }
    if (response.status < HttpStatus.OK || response.status > HttpStatus.ACCEPTED) {
        let message = 'Sorry an error occurred';
        const resAsText = yield response.text();
        const resBody = parseResponse(resAsText);
        if (typeof resBody === 'object') {
            message = resBody.message;
        }
        else {
            message = resBody;
        }
        if (message.includes('\n')) {
            message = message.substring(message.indexOf('\n'));
        }
        throw new ServiceError(message, response.status);
    }
    let text = yield response.text();
    if (response.status === HttpStatus.ACCEPTED) {
        text = (_a = response.headers.get('Location')) !== null && _a !== void 0 ? _a : '';
    }
    return (!text || text.length === 0 ? null : parseResponse(text));
});
export const handleCall = (func) => __awaiter(void 0, void 0, void 0, function* () {
    var _b;
    try {
        const result = yield func();
        return { result, error: undefined };
    }
    catch (e) {
        const errorMessage = (_b = e.message) !== null && _b !== void 0 ? _b : e.toString();
        return { result: undefined, error: errorMessage };
    }
});
//# sourceMappingURL=data:application/json;base64,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